export default __webpack_public_path__ + "static/media/circleQuestion.a1e2092e.svg";